<template>
    <div class="home-banner d-flex align-items-center h-100">
        <div class="swiper home-banner-copy w-100 h-100">
            <div class="swiper-wrapper h-100">
                <div v-for="banner in bannerSlides" :key="banner.displayText"
                     :class="['swiper-slide d-flex align-items-center flex-column', {'background-darken' : banner.slideImageDarken}, getBannerCopyColour(banner), getBannerDirection(banner) ]">
                    <div v-if="getForegroundImageUrl(banner)" class="justify-content-center align-items-center" >
                        <img class="img-fluid d-flex foreground-img py-2 py-sm-3 py-lg-0" :src="getForegroundImageUrl(banner)" alt="" />
                    </div>
                    <div class="slide-content-right">
                        <div>
                            <h2 class="banner-title text-uppercase font-weight-bold w-100">{{banner.displayText}}</h2>
                            <p class="banner-subtext"><i>{{banner.slideCopy}}</i></p>
                        </div>
                        <a target="_top" v-if="banner.slideLink" :href="banner.slideLink.url" :class="['btn mt-lg-3 px-5 text-uppercase rounded-0', getBannerLinkColour(banner)]" tabindex="-1">{{banner.slideLink.text}}</a>
                    </div>

                    <span v-if="banner.slideImageDarken" class="background-darken-overlay"></span>
                    <img class="img" :src="getMobileImageUrl(banner)" alt="" />
                </div>
            </div>
            <div class="swiper-pagination mb-2"></div>
        </div>
        <template v-if="bannerSlides.length > 1">
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </template>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import SwiperCore, { Navigation, Pagination } from 'swiper/core';
    SwiperCore.use([Navigation, Pagination]);

    export default {
        data() {
            return {
                swiper: null,
                bannerSlides: [{ "slideImageDarken": true, "slideImage": { "urls": [""] }, "slideForegroundImage": { "urls": [""] } }],
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        props: ["banner"],
        watch: {
            banner: {
                handler() {
                    if (this.banner) {
                        this.bannerSlides = this.banner;
                        this.$nextTick(() => {
                            this.swiperInnit();
                        })
                    }
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.reinnitSwiper);
            this.swiperInnit();
        },
        unmounted() {
            window.removeEventListener('resize', this.reinnitSwiper);
        },
        methods: {
            swiperInnit() {
                this.swiper = new Swiper('.home-banner-copy', {
                    slidesPerView: 1,
                    allowTouchMove: false,
                    loop: true,
                    pagination: {
                        el: "#HomeHeader .swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: "#HomeHeader .swiper-button-next",
                        prevEl: "#HomeHeader .swiper-button-prev",
                    },
                    on: {
                        activeIndexChange: function () {
                            var target = this.activeIndex;
                            this.slideTo(target);

                            var slideCount = this.slides.length - 2;
                            if (target > slideCount) {
                                target = 1;
                            }
                            if (target == 0) {
                                target = slideCount;
                            }

                            var currentActive = document.querySelector("#HomeHeader .swiper-pagination-bullet-active");
                            if (currentActive) {
                                currentActive.classList.remove("swiper-pagination-bullet-active");
                                document.querySelectorAll("#HomeHeader .swiper-pagination-bullet")[target - 1].classList.add("swiper-pagination-bullet-active");
                            }
                            return;
                        },
                    },
                });
            },
            reinnitSwiper() {
                this.swiper.update();
            },
            getBannerCopyColour(slide) {
                return slide.slideCopyColour ? slide.slideCopyColour : 'text-white';
            },
            getBannerLinkColour(slide) {
                return slide.slideLinkColour ? slide.slideLinkColour : 'btn-yellow';
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getMobileImageUrl(banner) {
                var img = banner.slideImage.urls[0];
                if (banner.slideImageMobile && banner.slideImageMobile.urls && banner.slideImageMobile.urls.length > 0) {
                    img = banner.slideImageMobile.urls[0];
                }
                return this.getImageUrl(img);
            },
            getForegroundImageUrl(banner) {
                if (banner.slideForegroundImage.urls.length > 0) {
                    var img = banner.slideForegroundImage.urls[0];
                    return this.getImageUrl(img);
                } else {
                    return null;
                }
            },
            getBannerDirection(banner) {
                if (banner.slideForegroundImage.urls.length > 0) {
                    return banner.foregroundImagePositioning || '';
                }
                return '';
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        }
    };
</script>